<template>
  <div class="pubg-recall-wrapper">
    <div class="t-label">
      <p>召回进度</p>
    </div>
    <div class="t-pro-list">
      <div class="item">
        <img src="https://imgheybox.max-c.com/oa/2021/08/09/e27aa84bf8cfc499f3c016fd17200792.png" :style="stage > 0 ? '' : '-webkit-filter: grayscale(100%); filter: grayscale(100%);'">
        <div class="desc">
          <div class="label" :style="stage > 0 ? 'color: #F1B238' : 'color: #EEEEEE'">绑定steam</div>
          <div class="text">库存中有PUBG</div>
        </div>
      </div>
      <div class="t-arrow">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="4" height="4" :fill="stage >= 1? '#F1B238' : '#939393'"/>
          <rect x="4" y="4" width="4" height="4" :fill="stage >= 1? '#F1B238' : '#939393'"/>
          <rect y="8" width="4" height="4" :fill="stage >= 1? '#F1B238' : '#939393'"/>
        </svg>
      </div>
      <div class="item">
        <img src="https://imgheybox.max-c.com/oa/2021/08/09/53351610778d918c7960f7356b18ab1c.png" :style="stage > 1 ? '' : '-webkit-filter: grayscale(100%); filter: grayscale(100%);'">
        <div class="desc">
          <div class="label" :style="stage > 1 ? 'color: #F1B238' : 'color: #EEEEEE'">绑定战绩</div>
          <div class="text"></div>
        </div>
      </div>
      <div class="t-arrow">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="4" height="4" :fill="stage >= 2? '#F1B238' : '#939393'"/>
          <rect x="4" y="4" width="4" height="4" :fill="stage >= 2? '#F1B238' : '#939393'"/>
          <rect y="8" width="4" height="4" :fill="stage >= 2? '#F1B238' : '#939393'"/>
        </svg>
      </div>
      <div class="item">
        <img src="https://imgheybox.max-c.com/oa/2021/08/09/4893a1869c14721177b22104147c6e56.png" :style="stage > 2 ? '' : '-webkit-filter: grayscale(100%); filter: grayscale(100%);'">
        <div class="desc">
          <div class="label" :style="stage > 2 ? 'color: #F1B238' : 'color: #EEEEEE'">检测老兵</div>
          <div class="text">15日内无对局</div>
        </div>
      </div>
      <div class="t-arrow">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="4" height="4" :fill="stage >= 3? '#F1B238' : '#939393'"/>
          <rect x="4" y="4" width="4" height="4" :fill="stage >= 3? '#F1B238' : '#939393'"/>
          <rect y="8" width="4" height="4" :fill="stage >= 3? '#F1B238' : '#939393'"/>
        </svg>
      </div>
      <div class="item">
        <img src="https://imgheybox.max-c.com/oa/2021/08/09/b10301730d002e27569b5b0e0dc011f6.png" :style="stage > 3 ? '' : '-webkit-filter: grayscale(100%); filter: grayscale(100%);'">
        <div class="desc">
          <div class="label" :style="stage > 3 ? 'color: #F1B238' : 'color: #EEEEEE'">对局1场</div>
          <div class="text">存活≥8分钟</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-pubg-recall_recall',
  props: {
    stage: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" scoped>
.pubg-recall-wrapper {
  width: 100%;
  padding: 10px 0px 12px 4px;
  margin-top: 11px;
  background: url('https://imgheybox.max-c.com/oa/2023/05/25/1677f876475bf724f21aa7f8d3a23f15.png') no-repeat center / cover;
  position: relative;
  .t-pro-list {
    width: 100%;
    padding-left: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t-arrow {
      width: 8px;
      flex-shrink: 0;
    }
    .item {
      width: 0;
      flex: 1;
      display: flex;
      flex-flow: column;
      align-items: center;
      .desc {
        text-align: center;
        .label {
          color: #FFFFFF;
          font-size: 12px;
        }
        .text {
          height: 14px;
          margin-top: 2px;
          line-height: 14px;
          font-size: 10px;
          color: #EEEEEE;
          white-space: nowrap;
        }
      }
      img {
        width: 46px;
        height: 46px;
        margin-bottom: 2px;
      }
    }
  }
  .t-label {
    width: 24px;
    height: 100%;
    padding: 0 4px;
    margin-right: 6px;
    background: linear-gradient(90deg, rgba(241, 178, 56, 0.4) 0%, rgba(241, 178, 56, 0) 100%);
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    p {
      text-align: center;
      font-weight: 600;
      font-size: 12px;
      line-height: 17px;
      color: #FFFFFF;
    }
  }
}
</style>